import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, MapPin, Mail, Phone } from 'lucide-react';
import { Separator } from './ui/separator';

export default function Footer() {
  return (
    <footer className="bg-muted mt-16" data-testid="site-footer">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-screen-xl py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Interio Mart</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Premium interior design studio creating minimalist, elegant spaces in Bengaluru and Mumbai.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-4 text-muted-foreground">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/gallery" className="text-sm hover:text-primary transition-colors" data-testid="footer-gallery-link">Gallery</Link></li>
              <li><Link to="/services" className="text-sm hover:text-primary transition-colors" data-testid="footer-services-link">Services</Link></li>
              <li><Link to="/about" className="text-sm hover:text-primary transition-colors" data-testid="footer-about-link">About Us</Link></li>
              <li><Link to="/faqs" className="text-sm hover:text-primary transition-colors" data-testid="footer-faqs-link">FAQs</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-primary transition-colors" data-testid="footer-contact-link">Contact</Link></li>
            </ul>
          </div>

          {/* Bengaluru Location */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-4 text-muted-foreground">Bengaluru</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
                <p className="text-sm text-muted-foreground">
                  Ground floor, Interio Mart, G-A, No 5AC, 905, Outer Ring Road, HRBR Layout, Babusapalya, Bengaluru, Karnataka 560043
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-muted-foreground" />
                <a href="tel:+918310951921" className="text-sm hover:text-primary transition-colors">+91 8310951921</a>
              </div>
            </div>
          </div>

          {/* Mumbai Location */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide mb-4 text-muted-foreground">Mumbai</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-muted-foreground flex-shrink-0" />
                <p className="text-sm text-muted-foreground">
                  Bharat compound, GM link Road, Goregaon East, Mumbai 400063
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-muted-foreground" />
                <a href="tel:+918310951921" className="text-sm hover:text-primary transition-colors">+91 8310951921</a>
              </div>
            </div>
          </div>
        </div>

        <Separator className="my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Interio Mart. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="mailto:info@interiomart.co.in"
              className="flex items-center gap-2 text-sm hover:text-primary transition-colors"
              data-testid="footer-email-link"
            >
              <Mail className="h-4 w-4" />
              info@interiomart.co.in
            </a>
            <a
              href="https://www.instagram.com/interiomart23"
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-sm hover:text-primary transition-colors"
              aria-label="Follow us on Instagram"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" />
              Instagram
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}